import React from 'react'

export function DrawerContent({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return <div className={'px-10 pt-10 max-w-[420px] mx-auto'}>{children}</div>
}
